import { HttpRequestClass } from '../../util/http';
import { userData } from '../../util/userData';
import { IAllSurveysTypeOption, ICustomerType, IHierarchyReference, IJsTreeCoreDataNode, IProject, ISegmentChildReference, ISegmentReference, NewProjectApiActions } from './interfaces';

export class NewProjectHttpClass extends HttpRequestClass {
  getCustomerTypes() {
    const method = 'POST'
    return this.fetch<ICustomerType[]>('scripts/customer_type/get_all', { method })
  }

  getAllSurveysCombinedOptions(): IAllSurveysTypeOption[] {
    return [
      { display: 'Include All Questions', value: 'All' },
      { display: 'Include Only Common Questions', value: 'Common' },
      { display: 'Include Only Common with All Open Ended Questions', value: 'CommonWithOpen' },
    ]
  }

  getProjects() {
    return this.newProjectFetch('getprojects')
  }

  getSurveys() {
    return this.newProjectFetch('getsurveys')
  }

  getSegments(clientAbbr: string) {
    return this.newProjectFetch('getsegments', { clientAbbr })
  }

  mapSegmentsToJsTreeNodes(segments: ISegmentReference[]): IJsTreeCoreDataNode[] {
    return segments.map<IJsTreeCoreDataNode>((segment: ISegmentReference): IJsTreeCoreDataNode => {
      const id = segment.avid
      const text = segment.avidLabel
      //let children = []

      // if (Array.isArray(segment.segmentChildren)) {
      //   children = segment.segmentChildren.map((s) => ({
      //     id: s.avid,
      //     text: s.avidLabel
      //   }))
      // }

      return { id, text } //, children }
    })
  }

  getHierarchies(clientAbbr: string) {
    return this.newProjectFetch('gethierarchies', { clientAbbr })
  }

  mapHierarchiesToJsTreeNodes(hierarchys: IHierarchyReference[]): IJsTreeCoreDataNode[] {
    return hierarchys.map<IJsTreeCoreDataNode>((hierarchy: IHierarchyReference): IJsTreeCoreDataNode => {
      const id = hierarchy.avid
      const text = hierarchy.avidLabel

      return { id, text }
    })
  }

  saveProject(project: IProject) {
    return this.newProjectFetch('save', { project })
  }

  private newProjectFetch<T = IProject[]>(action: NewProjectApiActions, options: { clientAbbr?: string, project?: IProject } = {}) {
    const url = 'https://f3cdiu9emb.execute-api.us-east-1.amazonaws.com/Dev/new-project-wizard'
    const method = 'POST'

    return userData.getToken().then((tokenRes) => {
      const { session, userId } = tokenRes
      const { clientAbbr, project } = options
      const body = JSON.stringify({ session, userId, action, clientAbbr, project })

      return this.fetch<T>(url, { method, body }).then((data) => {
        if (data && typeof data === 'object' && 'errorMessage' in data) { throw data }

        return data
      })
    })
  }
}

export const NewProjectHttp = new NewProjectHttpClass()
